var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketCreate" } }, [
    _c(
      "div",
      { staticClass: "dialog-content" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "context" }, [
          _vm._v(
            "To make a new ticket on behalf of unit, select the property, then type in the unit number. select a ticket type, enter a title, and describe the issue at hand."
          )
        ]),
        _vm._v(" "),
        _c("v-select", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name === "tickets",
              expression: "$route.name === 'tickets'"
            }
          ],
          ref: "selectPropertyTickets",
          attrs: {
            label: "Property",
            "prepend-icon": "mdi-domain",
            "item-text": "name",
            "item-value": "_id",
            rules: _vm.rules.property,
            items: _vm.properties,
            disabled: _vm.properties.length === 1 || _vm.$route.name === "units"
          },
          model: {
            value: _vm.ticket.property,
            callback: function($$v) {
              _vm.$set(_vm.ticket, "property", $$v)
            },
            expression: "ticket.property"
          }
        }),
        _vm._v(" "),
        _c("v-text-field", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name === "units",
              expression: "$route.name === 'units'"
            }
          ],
          attrs: {
            label: "Property",
            "prepend-icon": "mdi-domain",
            disabled: "",
            rules: _vm.rules.property,
            placeholder: _vm.$store.getters.property(_vm.ticket.property).name
          }
        }),
        _vm._v(" "),
        _c("v-text-field", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$route.name === "units",
              expression: "$route.name === 'units'"
            }
          ],
          ref: "selectUnit",
          attrs: {
            label: "Unit",
            "prepend-icon": "mdi-home",
            rules: _vm.rules.unit,
            items: _vm.units,
            disabled: "",
            placeholder: _vm.$store.getters.unit(_vm.ticket.unit).title
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "property-required",
            class: { active: _vm.ticket.property }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.useUnitSearch && _vm.$route.name === "tickets",
                    expression: "useUnitSearch && $route.name === 'tickets'"
                  }
                ]
              },
              [
                _c("v-select", {
                  ref: "searchUnit",
                  attrs: {
                    label: "Unit",
                    "prepend-icon": "mdi-home",
                    autocomplete: "",
                    "item-text": "title",
                    "item-value": "_id",
                    rules: _vm.rules.unit,
                    items: _vm.units,
                    "search-input": _vm.unitSearch,
                    loading: _vm.ticket.property && _vm.unitsLoading
                  },
                  on: {
                    "update:searchInput": function($event) {
                      _vm.unitSearch = $event
                    }
                  },
                  model: {
                    value: _vm.ticket.unit,
                    callback: function($$v) {
                      _vm.$set(_vm.ticket, "unit", $$v)
                    },
                    expression: "ticket.unit"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.useUnitSearch && _vm.$route.name === "tickets",
                    expression: "!useUnitSearch && $route.name === 'tickets'"
                  }
                ]
              },
              [
                _c("v-select", {
                  ref: "selectUnit",
                  attrs: {
                    label: "Unit",
                    "prepend-icon": "mdi-home",
                    "item-text": "title",
                    "item-value": "_id",
                    rules: _vm.rules.unit,
                    items: _vm.units
                  },
                  model: {
                    value: _vm.ticket.unit,
                    callback: function($$v) {
                      _vm.$set(_vm.ticket, "unit", $$v)
                    },
                    expression: "ticket.unit"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("v-select", {
              ref: "selectTicketTag",
              attrs: {
                "prepend-icon": "mdi-tag",
                label: "Ticket Tags",
                chips: "",
                multiple: "",
                "item-value": "_id",
                "item-text": "title",
                rules: _vm.rules.type,
                items: _vm.ticketTags
              },
              on: {
                change: function($event) {
                  _vm.$refs.selectTicketTag.blur()
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "selection",
                  fn: function(data) {
                    return [
                      _c(
                        "div",
                        { staticClass: "vo-tag" },
                        [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(data.item.title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "tag-btn",
                              attrs: { fab: "", flat: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.removeTicketTag(data.item, $event)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.ticket.type,
                callback: function($$v) {
                  _vm.$set(_vm.ticket, "type", $$v)
                },
                expression: "ticket.type"
              }
            }),
            _vm._v(" "),
            _c("v-text-field", {
              ref: "inputTitle",
              attrs: {
                rules: _vm.rules.title,
                "prepend-icon": "mdi-format-title",
                label: "Title"
              },
              model: {
                value: _vm.ticket.title,
                callback: function($$v) {
                  _vm.$set(_vm.ticket, "title", $$v)
                },
                expression: "ticket.title"
              }
            }),
            _vm._v(" "),
            _c("v-text-field", {
              ref: "inputDescription",
              attrs: {
                rules: _vm.rules.description,
                "prepend-icon": "mdi-note-text",
                "no-resize": "",
                "multi-line": "",
                rows: 3,
                label: "Description"
              },
              model: {
                value: _vm.ticket.body,
                callback: function($$v) {
                  _vm.$set(_vm.ticket, "body", $$v)
                },
                expression: "ticket.body"
              }
            }),
            _vm._v(" "),
            _c("vo-image-select", { ref: "imageSelect", attrs: { max: 5 } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "consent-section" },
              [
                _c("div", { staticClass: "consent-context" }, [
                  _vm._v(
                    " In order to serve your request, we require your consent to enter your residence. This is necessary to submit your ticket to us, and for us to proceed. By checking this box, you consent to entry into your unit."
                  )
                ]),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: { label: "I consent", color: "primary" },
                  model: {
                    value: _vm.ticket.consent,
                    callback: function($$v) {
                      _vm.$set(_vm.ticket, "consent", $$v)
                    },
                    expression: "ticket.consent"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { flat: "", color: "info", disabled: _vm.lockout.on },
            on: {
              click: function($event) {
                _vm.routeRemoveQueries(["dialog", "dialogItem"])
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { flat: "", color: "primary", loading: _vm.lockout.on },
            on: { click: _vm.create }
          },
          [_vm._v("Create")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "emergency" }, [
      _vm._v("If this is an "),
      _c("span", { staticClass: "red-text" }, [_vm._v("emergency")]),
      _vm._v(", please call your building manager immediately.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89158150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89158150","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketCreate.vue
// module id = 596
// module chunks = 4